import {
  GET_INVENTORY_COSTS,
  API_ERROR,
  SET_INVENTORY_COSTS,
  SET_INVENTORY_COST_FILTER,
  EMPTY_INVENTORY_COST,
} from './actionTypes';

const initialState = {
  inventoryCosts: [],
  filter: {
    offSet: 0,
    limit: 10,
    pages: 0,
    currentPage: 1,
    query: ''
  },
  error: '',
  loading: false,
};

const inventoryCost = (state = initialState, action) => {
  switch (action.type) {
    case GET_INVENTORY_COSTS:
      state = {
        ...state,
        loading: true,
      };
      break;
    case SET_INVENTORY_COSTS:
      state = {
        ...state,
        inventoryCosts: action.payload,
        loading: false,
      };
      break;
    case SET_INVENTORY_COST_FILTER:
      state = {
        ...state,
        filter: {
          ...state.filter,
          [action.payload.field]: action.payload.value,
        },
      };
      break;
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default inventoryCost;
